import { useCallback, useMemo } from 'react'
import { changedBrand } from '@/utils/formatBrand'
import Container from '../Context'
import type { IKEYS } from '../i18n'
import in18nMaps from '../i18n'

export const useTranslation = () => {
  const { lang } = Container.useContainer()

  const data = useMemo(() => {
    return changedBrand(in18nMaps[lang] || {}) || {}
  }, [lang])

  const t = useCallback(
    (key: IKEYS | string) => {
      return data[key]
    },
    [data]
  )

  return { t }
}
